import { MoonLoader } from "react-spinners";

export default function Loader(props){
    const { size = 40, color = '#3B82F6' } = props;
    return (
        <div className='flex justify-center items-center'>
            <MoonLoader size={size} color={color} />
        </div>
    )
}